export default "__VITE_ASSET__D4o9fOJo__"